import { c as _c } from "react/compiler-runtime";
type StatusColorIndicatorProps = {
  color: string;
  size?: 'sm' | 'md';
  shrink?: boolean;
  className?: string;
};
export function StatusColorIndicator(t0) {
  const $ = _c(2);
  const {
    color,
    size: t1,
    shrink: t2,
    className
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const shrink = t2 === undefined ? false : t2;
  const sizeClass = size === "sm" ? "size-2.5" : "size-3";
  const shrinkClass = shrink ? "shrink-0" : "";
  const t3 = `rounded-full ${sizeClass} ${shrinkClass} ${color} ${className ?? ""}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <span className={t3} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  return t4;
}